<template>
  <div
    class="alice-card"
    role="button"
    tabindex="0"
    @click="$emit('open', project)"
    @keydown.enter="$emit('open', project)"
  >
    <div
      class="alice-card__stripe"
      :style="{ background: project.clientColor }"
    />
    <div class="alice-card__body">
      <div class="alice-card__top">
        <ClientChip :name="project.client" :color="project.clientColor" />
        <StatusTag :status="project.status" />
      </div>
      <div class="alice-card__title">{{ project.title }}</div>
      <div class="alice-card__footer">
        <Avatar
          v-if="project.owner"
          :name="project.owner.name"
          :photo="project.owner.photo"
          :color="project.owner.color"
          :size="28"
        />
        <Avatar
          v-else
          name=""
          initials="—"
          color="var(--vp-grijs-20)"
          :size="28"
        />
        <div class="alice-card__owner">
          <div class="alice-card__owner-name">
            {{ project.owner ? project.owner.name : "Unassigned" }}
          </div>
          <div v-if="metaLine" class="alice-card__meta">{{ metaLine }}</div>
        </div>
        <div class="alice-card__rel">{{ createdRel }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar.vue";
import ClientChip from "./ClientChip.vue";
import StatusTag from "./StatusTag.vue";
import { relTime } from "./normalize";

export default {
  name: "AliceProjectCard",
  components: { Avatar, ClientChip, StatusTag },
  props: {
    project: { type: Object, required: true },
  },
  emits: ["open"],
  computed: {
    metaLine() {
      const parts = [];
      if (this.project.method) parts.push(this.project.method);
      if (typeof this.project.n === "number") parts.push(`n=${this.project.n}`);
      return parts.join(" · ");
    },
    createdRel() {
      return relTime(this.project.created);
    },
  },
};
</script>

<style scoped>
.alice-card {
  background: var(--vp-white);
  border: 1px solid var(--border-hairline);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  outline: 2px solid transparent;
  outline-offset: -2px;
  transition: outline-color var(--dur-fast) var(--ease-hover);
  border-radius: 0;
}
.alice-card:hover,
.alice-card:focus-visible {
  outline-color: var(--accent-100);
}
.alice-card__stripe {
  height: 6px;
  flex-shrink: 0;
}
.alice-card__body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
}
.alice-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}
.alice-card__title {
  font-family: var(--font-body);
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--vp-black);
  flex: 1;
}
.alice-card__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-hairline);
}
.alice-card__owner {
  flex: 1;
  min-width: 0;
}
.alice-card__owner-name {
  font-family: var(--font-ui);
  font-size: 12px;
  font-weight: 700;
  color: var(--vp-black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.alice-card__meta {
  font-family: var(--font-ui);
  font-size: 11px;
  color: var(--fg-3);
}
.alice-card__rel {
  font-family: var(--font-ui);
  font-size: 11px;
  color: var(--fg-3);
  text-align: right;
  white-space: nowrap;
}
</style>
